import { MATERIAL_TYPES } from '@mixtiles/web-backend-shared'
import { CDN_URL } from 'config/config'

export function getFrameImageName(
  frameColor: string,
  materialType: MATERIAL_TYPES
) {
  if (materialType === MATERIAL_TYPES.FRAMELESS) {
    return 'frameless'
  }

  let imageName = frameColor
  if (materialType === MATERIAL_TYPES.WIDE_FRAME) {
    imageName = `wide-${imageName}`
  }
  return imageName
}
export function getFrameImage(
  frameColor: string,
  materialType: MATERIAL_TYPES
) {
  const imageName = getFrameImageName(frameColor, materialType)
  return `${CDN_URL}/tiles/frames/${imageName}.png`
}
